import PT from 'prop-types';
import React from 'react';

import { useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import { withInputError } from '~/ui/hocs/form';
import styles from '~/ui/styles';
import { validateEmail } from '~/utils/strings';

const widths = {
  s: '200px',
  m: '260px',
  l: '520px',
  fullWidth: '100%',
};

const useEmailValidation = ({ value }) => {
  const intl = useIntl();

  if (value && !validateEmail(value)) {
    return intl.formatMessage({
      id: 'EmailInput.invalidEmail',
      defaultMessage: 'Invalid email',
      description: 'Error message for invalid email format',
    });
  }
  return null;
};

function EmailInput({
  disabled = false,
  error,
  placeholder,
  value,
  width = 'm',
  onChange,
  onBlur,
}) {
  return (
    <Box
      as="input"
      disabled={disabled}
      placeholder={placeholder}
      px={4}
      sx={{
        ...styles.form.input,
        ...(error ? styles.form.error : {}),
        width: widths[width],
      }}
      type="email"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}

EmailInput.propTypes = {
  /** Disables the input component */
  disabled: PT.bool,
  /** Input error */
  error: PT.string,
  /** Placeholder */
  placeholder: PT.string,
  /** Text input value */
  value: PT.string,
  /** Input width */
  width: PT.oneOf(['s', 'm', 'l', 'fullWidth']),
  /** Callback that returns new selected value */
  onChange: PT.func.isRequired,
};

export default withInputError(EmailInput, useEmailValidation);
